// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2yFJ9","select":"Header_select__3jXCd","clinic":"Header_clinic__3rT68"};